export default "__VITE_ASSET__C4t8IF_a__"